import { render } from "./NewsFiles.vue?vue&type=template&id=50fe4f8b"
import script from "./NewsFiles.vue?vue&type=script&lang=js"
export * from "./NewsFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__